import {Component, inject, input, signal} from '@angular/core';
import {FormControl} from '@angular/forms';
import {TranslateService} from '@ngx-translate/core';
import {MultiDropdown} from '../../../../components/multi-dropdown/multi-dropdown';
import {CustomerState} from '../../../../../api';

@Component({
  selector: 'elcia-customer-state-dropdown',
  imports: [
    MultiDropdown
  ],
  templateUrl: './customer-state-dropdown.html',
  styleUrl: './customer-state-dropdown.scss',
})
export class CustomerStateDropdown {

  control = input.required<FormControl>();

  private readonly translateService = inject(TranslateService);

  states = signal([
    {
      id: CustomerState.IsActive,
      label: this.translateService.instant('customer.is-active'),
    } as CustomerStateModel,
    {
      id: CustomerState.IsInactive,
      label: this.translateService.instant('customer.inactive'),
    } as CustomerStateModel,
  ]);
}

interface CustomerStateModel {
  id: CustomerState;
  label: string;
}
